import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import { Center } from '@/components/ui/center'
import { Spinner } from '@/components/ui/spinner'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import SwitchUser from '@/modules/profile/SwitchUser'
import { fetchCurrentUserThunk } from '@/redux/slices/currentUserSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { Stack, useRouter } from 'expo-router'
import { useEffect } from 'react'

export default function SwitchUserPage() {
  const dispatch = useAppDispatch()
  const router = useRouter()
  const headerLeftItems = useWebBackButton('/login')

  const currentUser = useAppSelector(state => state.currentUser.user)

  useEffect(() => {
    dispatch(fetchCurrentUserThunk())
  }, [dispatch])

  const handleSwitchSuccess = () => {
    router.replace('/forms')
  }

  if (!currentUser)
    return (
      <Center className="h-[50vh]">
        <Spinner />
      </Center>
    )

  return (
    <>
      <Stack.Screen
        options={{
          ...buildScreenHeaderItems({ left: headerLeftItems }),
        }}
      />
      <SwitchUser currentUser={currentUser} onSwitchSuccess={handleSwitchSuccess} />
    </>
  )
}
